import Vue from 'vue'
const state = {
  commande: {
    noCommande: null,
    noCommandeJDE: null,
    tsCommande: null,
    total: null,
    produits: [],
    demandeur: {},
    destinataire: {},
    commandeAgent: false,
    produitsQuantiteInsuffisante: [],
    commandeExcel: false
  }
}

const getters = {
  // Acces via  this.$store.getters.commande
  commande(state) {
    return state.commande
  },
  produits(state) {
    return state.commande == null ? null : state.commande.produits
  },
  produitsQuantiteInsuffisante(state) {
    return state.commande == null ? null : state.commande.produitsQuantiteInsuffisante
  },
  commandeAgent(state) {
    return state.commande == null ? null : state.commande.commandeAgent
  },
  typeLivraison(state) {
    return state.commande == null ? null : state.commande.typeLivraison
  },
  succursaleLivraisonDemande(state) {
    return state.commande == null
      ? null
      : state.commande.succursaleLivraisonDemande
  },
  statutCommande(state) {
    return state.commande == null ? null : state.commande.statutCommande
  },
  demandeur(state) {
    return state.commande == null ? null : state.commande.demandeur
  },
  destinataire(state) {
    return state.commande == null ? null : state.commande.destinataire
  },
  destinataireClient(state) {
    return state.commande == null ? null : state.commande.destinataireClient
  }
}

const actions = {
  // Commande
  garderCommande({ commit }, commandeData) {
    commit('mGarderCommande', commandeData)
  },
  initialiserCommande({ commit }) {
    commit('mInitialiserCommande')
  },

  // Demandeur
  associerDemandeur({ commit }, demandeurData) {
    commit('mSetterDemandeurCommande', {
      demandeur: demandeurData
    })
  },

  // Destinataire
  associerDestinataire({ commit }, destinataireData) {
    commit('mSetterDestinataireCommande', destinataireData)
  },

  // Commentaire
  associerCommentaire({ commit }, commentaireData) {
    commit('mSetterCommentaireCommande', {
      commentaire: commentaireData
    })
  },

  // TypeLivraison
  //associerTypeLivraison({ commit }, typeLivraisonData) {
  //  commit('mSetterTypeLivraisonCommande', typeLivraisonData
  //  )
  //},

  // Produits
  ajouterProduit({ commit }, produitData) {
    commit('mAjouterProduit', produitData)
  },
  ajouterProduitLot({ commit }, listeProduits) {
    commit('mAjouterProduitLot', listeProduits)
  },
  supprimerProduit({ commit }, index) {
    commit('mSupprimerProduit', index)
  }
}

const mutations = {
  // Demande
  mGarderCommande(state, commandeData) {
    // state.commande = commandeData
    // Avec Object.assign, on "garde" les attributs existants
    Object.assign(state.commande, commandeData)

    // Si les enfant n'existent pas, on les initialize
    if (commandeData.produits == null) {
      state.commande.produits = []
    }
  },
  mInitialiserCommande(state) {
    state.commande = {
      noCommande: null,
      noCommandeJDE: null,
      tsCommande: null,
      total: null,
      produits: [],
      demandeur: {},
      destinataire: {},
      destinataireClient: {},
      commandeAgent: false,
      typeLivraison: {},
      produitsQuantiteInsuffisante: [],
      commandeExcel: false
    }
  },

  // Demandeur
  mSetterDemandeurCommande(state, { demandeurData }) {
    state.commande.demandeur = demandeurData
  },

  // Destinataire
  mSetterDestinataireCommande(state, { destinataireData }) {
    state.commande.destinataire = destinataireData
  },

  // Destinataire
  mSetterDestinataireClientCommande(state, { clientData }) {
    state.commande.destinataireClient = clientData
  },

  // Commentaire
  mSetterCommentaireCommande(state, commentaireData) {
    state.commande.commentaire = commentaireData
  },

  mSetterTypeLivraisonCommande(state, { typeLivraisonData }) {
    state.commande.typeLivraison = typeLivraisonData
  },

  // Produits
  mAjouterProduit(state, produitData) {
    state.commande.produits.push(produitData)
  },
  mAjouterProduitLot(state, listeProduits) {
    for (let i = 0; i < listeProduits.length; i++) {
      state.commande.produits.push(listeProduits[i])
    }
  },
  mSupprimerProduit(state, ligne) {
    const index = state.commande.produits.indexOf(ligne)
    state.commande.produits.splice(index, 1)
  }
}

export default {
  state,
  mutations,
  getters,
  actions
}
